import spring from "../../assets/Frameworks/spring.png";
import flutter from "../../assets/Frameworks/flutter.png";
import bootstrap from "../../assets/Frameworks/bootstrap.png";

const nextjs = 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nextjs/nextjs-original.svg';
const tailwind = 'https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/tailwindcss/tailwindcss-original.svg';

const FrameworkElements = [
  { id: 1, path: spring, title: "Spring", style: "shadow-green-500" },
  { id: 2, path: nextjs, title: "Next.js", style: "shadow-green-500" },
  { id: 3, path: flutter, title: "Flutter", style: "shadow-green-500" },
  { id: 4, path: tailwind, title: "Tailwind CSS", style: "shadow-green-500" },
  { id: 5, path: bootstrap, title: "Bootstrap", style: "shadow-green-500" },
];

export default FrameworkElements;
